var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2547",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2551"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2561"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2559"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2553",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2557",
    clipPath: "url(#clipPath2561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2563",
    transform: "translate(438.8887,360.8887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -91 c -22.091,0 -40,17.909 -40,40 v 91",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2567",
    transform: "translate(438.8887,360.8887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -300.889 c 0,-22.091 -17.908,-40 -40,-40 h -285.889 c -22.091,0 -40,17.909 -40,40 v 392 c 0,22.092 17.909,40 40,40 h 195.445 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2569"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2571",
    transform: "translate(255,260.9336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -143.934",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2575",
    transform: "translate(199.6699,218.6699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 55.33,55.33 110.66,0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2577"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload-2.8d3b798523d4135b0b9471f70e7dae28.svg";
export { ForwardRef as ReactComponent };